import PropTypes from 'prop-types'
import { Element } from '../../../common/html/element'

const Note = ({ note }) => {
  return (
    <span>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Element
        style={{
          color: '#3A414B',
          wordBreak: 'break-word',
          textAlign: 'justify',
        }}
      >
        {note}
      </Element>
    </span>
  )
}

Note.propTypes = {
  note: PropTypes.string.isRequired,
}

export default Note
